<template>
  <div id="Surface">

    <Head />
    <div class="surface">
      <div class="leftNav">
        <decLeftNav ref="LeftNav" @isReportID="getReportID" />
      </div>
      <div class="Main">
        <div class="explain">
          <div>
            <img src="../../assets/Declare/6b6a83d83c3d2a565d9084b5e4e512a.png" alt />
            申报填写说明
          </div>
          <p>
            1.建议使用最新版本的谷歌浏览器 、 搜狗浏览器、360浏览器、QQ浏览器。
          </p>
          <p>
            2.当遇到填写乱码时请确认是否切换到极速模式，如红圈所示
            <img src="../../assets/Declare/topspeed.png" alt />
          </p>
          <p class="address">
            3.最新浏览器下载地址：
            <img src="../../assets/Declare/Google.png" />
            <a href="http://chrome.yscyxx.cn/" target="_blank">谷歌浏览器下载</a>
            <img src="../../assets/Declare/SOGO.png" />
            <a href="https://ie.sogou.com/" target="_blank">搜狗浏览器下载</a>
            <img src="../../assets/Declare/360.png" />
            <a href="https://browser.360.cn/ee/" target="_blank">360浏览器下载</a>
            <img src="../../assets/Declare/QQ.png" />
            <a href="https://browser.qq.com/?adtag=SEM170314031" target="_blank">QQ浏览器下载</a>
          </p>
        </div>
        <div class="mainIn">
          <div class="textNav">
            <div class="nTitle">
              <img src="../../assets/Declare/09.png" />申报表目录
            </div>
            <ul>
              <li v-for="(item, index) in textNav" :key="index" :class="{ active: NavI == index }">
                <div></div>
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="Table">
            <div id="tTitle">{{ textNav[NavI] }}</div>
            <div class="tMain">
              <div class="tMInput" v-if="NavI == 0">
                <div>
                  <div class="title">姓名:</div>
                  <input id="sblxrxm" type="text" v-model="value[0].sblxrxm"
                    @blur="addLattice('sblxrxm', value[0].sblxrxm)" placeholder="请输入姓名" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">职务</div>
                  <input id="sblxrzw" type="text" v-model="value[0].sblxrzw"
                    @blur="addLattice('sblxrzw', value[0].sblxrzw)" placeholder="请输入职务" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">电话</div>
                  <input id="sblxrdh" type="text" v-model="value[0].sblxrdh"
                    @blur="addLattice('sblxrdh', value[0].sblxrdh)" placeholder="请输入电话" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">手机</div>
                  <input id="sblxrsj" type="text" v-model="value[0].sblxrsj"
                    @blur="addLattice('sblxrsj', value[0].sblxrsj)" placeholder="请输入手机" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">传真</div>
                  <input id="sblxrcz" type="text" v-model="value[0].sblxrcz"
                    @blur="addLattice('sblxrcz', value[0].sblxrcz)" placeholder="请输入传真" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">电子邮箱</div>
                  <input id="dzyx" type="text" v-model="value[0].dzyx" @blur="addLattice('dzyx', value[0].dzyx)"
                    placeholder="请输入电子邮箱" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">邮编</div>
                  <input id="yb" type="text" v-model="value[0].yb" @blur="addLattice('yb', value[0].yb)"
                    placeholder="请输入邮编" />
                  <span>*</span>
                </div>
              </div>
              <div class="tMInput" v-if="NavI == 1">
                <div>
                  <div class="title">成果名称</div>
                  <input id="cgmc" type="text" v-model="value[1].cgmc" @blur="addLattice('cgmc', value[1].cgmc)"
                    placeholder="请输入成果名称" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">申报单位详细地址</div>
                  <input id="sbdwdz" type="text" v-model="value[1].sbdwdz" @blur="addLattice('sbdwdz', value[1].sbdwdz)"
                    placeholder="请输入申报单位详细地址" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">成果分类</div>
                  <div class="cgfl">
                    <div class="major2Value" @click="showCgfl(1)" v-if="majorShow">
                      <span>{{ ParentClassName }}</span>
                      <i class="icon-triangle-dowm"></i>
                    </div>
                    <select id="cgfl1" @change="getmajor2" v-else v-model="major1Value">
                      <option value selected disabled hidden>请选择一级专业方向</option>
                      <option v-for="(item, i) in major1" :key="i" :value="item.Classname">
                        {{ item.Classname }}
                      </option>
                    </select>
                    <span>*</span>
                  </div>
                  <!-- <select @change="getmajor2" v-model="major1Value">
                  <option value>请选择一级专业方向</option>
                  <option
                    v-for="(item,i) in major1"
                    :key="i"
                    :value="item.Classname"
                  >{{item.Classname}}</option>
                  </select>-->
                </div>
                <div>
                  <div class="title" style="margin-bottom: 0.4rem"></div>
                  <div class="cgfl">
                    <div class="major2Value" @click="showCgfl(2)" v-if="majorShow1">
                      <span>{{ ClassName }}</span>
                      <i class="icon-triangle-dowm"></i>
                    </div>
                    <select id="cgfl2" v-model="major2Value" @change="getmajor3"
                      :disabled="major2.length > 0 ? false : true" v-else>
                      <option value selected disabled hidden>请选择二级专业方向</option>
                      <option v-for="(item, i) in major2" :key="i" :value="item.Classname">
                        {{ item.Classname }}
                      </option>
                    </select>
                    <span>*</span>
                  </div>
                </div>
                <div>
                  <div class="title">申报单位</div>
                  <input id="sbdw" type="text" v-model="value[1].sbdw" @blur="addLattice('sbdw', value[1].sbdw)"
                    placeholder="请输入申报单位" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">推荐单位</div>
                  <input id="tjdw" type="text" v-model="value[1].tjdw" @blur="addLattice('tjdw', value[1].tjdw)"
                    placeholder="请输入推荐单位" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">申报单位类型</div>
                  <input id="sbdwlx" type="text" v-model="value[1].sbdwlx" @blur="addLattice('sbdwlx', value[1].sbdwlx)"
                    placeholder="请输入申报单位类型" />
                  <span>*</span>
                </div>
                <div>
                  <div class="title">申报单位规模</div>
                  <input id="sbdwgm" type="text" v-model="value[1].sbdwgm" @blur="addLattice('sbdwgm', value[1].sbdwgm)"
                    placeholder="请输入申报单位规模" />
                  <span>*</span>
                </div>

                <div class="t">
                  <p class="title">主要创造人(最多2人)</p>
                  <table>
                    <tr>
                      <th>姓名</th>
                      <th>职务</th>
                      <th>职称</th>
                    </tr>
                    <tr>
                      <td>
                        <input id="csrxm1" type="text" v-model="value[3].csrxm1"
                          @blur="addLattice('csrxm1', value[3].csrxm1)" />
                      </td>
                      <td>
                        <input id="csrzw1" type="text" v-model="value[3].csrzw1"
                          @blur="addLattice('csrzw1', value[3].csrzw1)" />
                      </td>
                      <td>
                        <input id="csrzc1" type="text" v-model="value[3].csrzc1"
                          @blur="addLattice('csrzc1', value[3].csrzc1)" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input id="csrxm2" type="text" v-model="value[3].csrxm2"
                          @blur="addLattice('csrxm2', value[3].csrxm2)" />
                      </td>
                      <td>
                        <input id="csrzw2" type="text" v-model="value[3].csrzw2"
                          @blur="addLattice('csrzw2', value[3].csrzw2)" />
                      </td>
                      <td>
                        <input id="csrzc2" type="text" v-model="value[3].csrzc2"
                          @blur="addLattice('csrzc2', value[3].csrzc2)" />
                      </td>
                    </tr>
                  </table>
                </div>
                <p class="title">参与创造人(最多10人)</p>
                <table>
                  <tr>
                    <th>姓名</th>
                    <th>职务</th>
                    <th>职称</th>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm1" type="text" v-model="value[3].cycsrxm1"
                        @blur="addLattice('cycsrxm1', value[3].cycsrxm1)" />
                    </td>
                    <td>
                      <input id="cycsrzw1" type="text" v-model="value[3].cycsrzw1"
                        @blur="addLattice('cycsrzw1', value[3].cycsrzw1)" />
                    </td>
                    <td>
                      <input id="cycsrzc1" type="text" v-model="value[3].cycsrzc1"
                        @blur="addLattice('cycsrzc1', value[3].cycsrzc1)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm2" type="text" v-model="value[3].cycsrxm2"
                        @blur="addLattice('cycsrxm2', value[3].cycsrxm2)" />
                    </td>
                    <td>
                      <input id="cycsrzw2" type="text" v-model="value[3].cycsrzw2"
                        @blur="addLattice('cycsrzw2', value[3].cycsrzw2)" />
                    </td>
                    <td>
                      <input id="cycsrzc2" type="text" v-model="value[3].cycsrzc2"
                        @blur="addLattice('cycsrzc2', value[3].cycsrzc2)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm3" type="text" v-model="value[3].cycsrxm3"
                        @blur="addLattice('cycsrxm3', value[3].cycsrxm3)" />
                    </td>
                    <td>
                      <input id="cycsrzw3" type="text" v-model="value[3].cycsrzw3"
                        @blur="addLattice('cycsrzw3', value[3].cycsrzw3)" />
                    </td>
                    <td>
                      <input id="cycsrzc3" type="text" v-model="value[3].cycsrzc3"
                        @blur="addLattice('cycsrzc3', value[3].cycsrzc3)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm4" type="text" v-model="value[3].cycsrxm4"
                        @blur="addLattice('cycsrxm4', value[3].cycsrxm4)" />
                    </td>
                    <td>
                      <input id="cycsrzw4" type="text" v-model="value[3].cycsrzw4"
                        @blur="addLattice('cycsrzw4', value[3].cycsrzw4)" />
                    </td>
                    <td>
                      <input id="cycsrzc4" type="text" v-model="value[3].cycsrzc4"
                        @blur="addLattice('cycsrzc4', value[3].cycsrzc4)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm5" type="text" v-model="value[3].cycsrxm5"
                        @blur="addLattice('cycsrxm5', value[3].cycsrxm5)" />
                    </td>
                    <td>
                      <input id="cycsrzw5" type="text" v-model="value[3].cycsrzw5"
                        @blur="addLattice('cycsrzw5', value[3].cycsrzw5)" />
                    </td>
                    <td>
                      <input id="cycsrzc5" type="text" v-model="value[3].cycsrzc5"
                        @blur="addLattice('cycsrzc5', value[3].cycsrzc5)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm6" type="text" v-model="value[3].cycsrxm6"
                        @blur="addLattice('cycsrxm6', value[3].cycsrxm6)" />
                    </td>
                    <td>
                      <input id="cycsrzw6" type="text" v-model="value[3].cycsrzw6"
                        @blur="addLattice('cycsrzw6', value[3].cycsrzw6)" />
                    </td>
                    <td>
                      <input id="cycsrzc6" type="text" v-model="value[3].cycsrzc6"
                        @blur="addLattice('cycsrzc6', value[3].cycsrzc6)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm7" type="text" v-model="value[3].cycsrxm7"
                        @blur="addLattice('cycsrxm7', value[3].cycsrxm7)" />
                    </td>
                    <td>
                      <input id="cycsrzw7" type="text" v-model="value[3].cycsrzw7"
                        @blur="addLattice('cycsrzw7', value[3].cycsrzw7)" />
                    </td>
                    <td>
                      <input id="cycsrzc7" type="text" v-model="value[3].cycsrzc7"
                        @blur="addLattice('cycsrzc7', value[3].cycsrzc7)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm8" type="text" v-model="value[3].cycsrxm8"
                        @blur="addLattice('cycsrxm8', value[3].cycsrxm8)" />
                    </td>
                    <td>
                      <input id="cycsrzw8" type="text" v-model="value[3].cycsrzw8"
                        @blur="addLattice('cycsrzw8', value[3].cycsrzw8)" />
                    </td>
                    <td>
                      <input id="cycsrzc8" type="text" v-model="value[3].cycsrzc8"
                        @blur="addLattice('cycsrzc8', value[3].cycsrzc8)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm9" type="text" v-model="value[3].cycsrxm9"
                        @blur="addLattice('cycsrxm9', value[3].cycsrxm9)" />
                    </td>
                    <td>
                      <input id="cycsrzw9" type="text" v-model="value[3].cycsrzw9"
                        @blur="addLattice('cycsrzw9', value[3].cycsrzw9)" />
                    </td>
                    <td>
                      <input id="cycsrzc9" type="text" v-model="value[3].cycsrzc9"
                        @blur="addLattice('cycsrzc9', value[3].cycsrzc9)" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input id="cycsrxm10" type="text" v-model="value[3].cycsrxm10"
                        @blur="addLattice('cycsrxm10', value[3].cycsrxm10)" />
                    </td>
                    <td>
                      <input id="cycsrzw10" type="text" v-model="value[3].cycsrzw10"
                        @blur="addLattice('cycsrzw10', value[3].cycsrzw10)" />
                    </td>
                    <td>
                      <input id="cycsrzc10" type="text" v-model="value[3].cycsrzc10"
                        @blur="addLattice('cycsrzc10', value[3].cycsrzc10)" />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="tMInput" v-if="NavI == 2">
                <div class="title">成果来源</div>
                <textarea v-model="value[2].cgly" @blur="addLattice('cgly', value[2].cgly)"
                  placeholder="请输入成果来源"></textarea>
                <div class="title">成果内涵</div>
                <textarea v-model="value[2].cgnh" @blur="addLattice('cgnh', value[2].cgnh)"
                  placeholder="请输入成果内涵"></textarea>
                <div class="title">主要创新点</div>
                <textarea v-model="value[2].zycxd" @blur="addLattice('zycxd', value[2].zycxd)"
                  placeholder="请输入主要创新点"></textarea>
                <div class="title">示范作用</div>
                <textarea v-model="value[2].sfzy" @blur="addLattice('sfzy', value[2].sfzy)"
                  placeholder="请输入示范作用"></textarea>
                <div class="title">
                  本成果何时经过何单位、何种鉴定，获何奖项
                </div>
                <textarea v-model="value[2].cgsyjl" @blur="addLattice('cgsyjl', value[2].cgsyjl)"
                  placeholder="请输入奖励信息"></textarea>
              </div>
              <div class="tMInput" v-if="NavI == 3">
                <table border="1" cellspacing="0" style="text-align: center">
                  <tr>
                    <th colspan="6" class="title">成果经济效益指标测算结果</th>
                  </tr>
                  <tr>
                    <td style="width: 15%">成果创造时间</td>
                    <td colspan="2" style="width: 20%; padding-left: 0.3rem">
                      <input type="text" v-model="value[4].cgczsjn"
                        @blur="addTimeLattice(value[4].cgczsjn, value[4].cgczsjy), addLattice('cgczsjn', value[4].cgczsjn)"
                        style="width: 30%" maxlength="4" />年
                      <input type="text" v-model="value[4].cgczsjy"
                        @blur="addTimeLattice(value[4].cgczsjn, value[4].cgczsjy), addLattice('cgczsjy', value[4].cgczsjy)"
                        style="width: 25%" maxlength="2" />
                      月
                    </td>
                    <td>成果应用年限</td>
                    <td colspan="2" style="padding-left: 0.5rem">
                      <input type="text" v-model="value[4].cgyynx" @blur="addLattice('cgyynx', value[4].cgyynx)"
                        style="width: 35%" maxlength="4" />年
                    </td>
                  </tr>
                  <tr>
                    <td>成果实施范围</td>
                    <td colspan="5">
                      <input type="text" v-model="value[4].cgssfw" @blur="addLattice('cgssfw', value[4].cgssfw)" />
                    </td>
                  </tr>
                  <tr>
                    <td>成果效益计算方法及公式</td>
                    <td colspan="5">
                      <!-- <textarea name="" id="" cols="10" rows="5" style="width:100%;heigth:100%" v-model="value[4].cgxyjs"></textarea> -->
                      <!-- <el-input type="textarea" :rows="2" v-model="value[4].cgxyjs"></el-input> -->
                      <Wan v-model="value[4].cgxyjs" @blur="addLattice('cgxyjs', value[4].cgxyjs)"></Wan>

                      <!-- <input type="text"  /> -->
                    </td>
                  </tr>
                  <tr>
                    <td>序号</td>
                    <td style="width: 20%">指标名称</td>
                    <td>计量单位</td>
                    <td style="width: 30%">时间</td>
                    <td>测算结果</td>
                    <td>备注</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>申报前一年效益额</td>
                    <td>万元</td>
                    <td>
                      <strong>{{ year }}</strong>年
                    </td>
                    <td>
                      <input type="text" v-model="value[4].sbqynxye" @blur="addLattice('sbqynxye', value[4].sbqynxye)" />
                    </td>
                    <td>
                      <input type="text" v-model="value[4].sbqynxyebz"
                        @blur="addLattice('sbqynxyebz', value[4].sbqynxyebz)" />
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>实施各年累计效益额</td>
                    <td>万元</td>
                    <td>
                      <input type="text" v-model="value[4].ssgn1" @blur="addLattice('ssgn1', value[4].ssgn1)"
                        style="width: 20%" maxlength="4" />年至
                      <input type="text" v-model="value[4].ssgn2" @blur="addLattice('ssgn2', value[4].ssgn2)"
                        style="width: 20%" maxlength="4" />年共
                      <input type="text" v-model="value[4].ssgnzn" @blur="addLattice('ssgnzn', value[4].ssgnzn)"
                        style="width: 20%" maxlength="4" />年
                    </td>
                    <td>
                      <input type="text" v-model="value[4].ssgnljxye"
                        @blur="addLattice('ssgnljxye', value[4].ssgnljxye)" />
                    </td>
                    <td>
                      <input type="text" v-model="value[4].ssgnljxyebz"
                        @blur="addLattice('ssgnljxyebz', value[4].ssgnljxyebz)" />
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>平均年度效益额</td>
                    <td>万元</td>
                    <td>
                      <input type="text" v-model="value[4].pjndxyen1" @blur="addLattice('pjndxyen1', value[4].pjndxyen1)"
                        style="width: 20%" maxlength="4" />年至
                      <input type="text" v-model="value[4].pjndxyen2" @blur="addLattice('pjndxyen2', value[4].pjndxyen2)"
                        style="width: 20%" maxlength="4" />年共
                      <input type="text" v-model="value[4].pjndxyezn" @blur="addLattice('pjndxyezn', value[4].pjndxyezn)"
                        style="width: 20%" maxlength="4" />年
                    </td>
                    <td>
                      <input type="text" v-model="value[4].pjndxye" @blur="addLattice('pjndxye', value[4].pjndxye)" />
                    </td>
                    <td>
                      <input type="text" v-model="value[4].pjndxyebz"
                        @blur="addLattice('pjndxyebz', value[4].pjndxyebz)" />
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>申报前一年效益贡献额</td>
                    <td>%</td>
                    <td>
                      <strong>{{ year }}</strong>年
                    </td>
                    <td>
                      <input type="text" v-model="value[4].sbqyngxl" @blur="addLattice('sbqyngxl', value[4].sbqyngxl)" />
                    </td>
                    <td>
                      <input type="text" v-model="value[4].sbqyngxlbz"
                        @blur="addLattice('sbqyngxlbz', value[4].sbqyngxlbz)" />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="tMInput" v-if="NavI == 4">
                <table border="1" cellspacing="0" class="Table">
                  <tr>
                    <th colspan="2">审核意见</th>
                  </tr>
                  <tr>
                    <td style="width: 50%">
                      <div class="yj">
                        <p class="top">本单位财务部门审核意见</p>
                        <div>
                          <span>盖章</span>
                          <p class="space">
                            年
                            <span></span>月 <span></span>日
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="yj">
                        <p class="top">法定代表人确认签字</p>
                        <div>
                          <span>盖章</span>
                          <p class="space">
                            年
                            <span></span>月 <span></span>日
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="gz">
                    <td style="text-align: center">
                      推荐单位
                      <br />初审意见
                    </td>
                    <td>
                      <div>
                        <span>盖章</span>
                        <p class="space">
                          年
                          <span></span>月 <span></span>日
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr class="gz">
                    <td style="text-align: center">
                      中国煤炭工业协会
                      <br />审定意见
                    </td>
                    <td>
                      <div>
                        <span>盖章</span>
                        <p class="space">
                          年
                          <span></span>月 <span></span>日
                        </p>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- <div class="btn" @click="next">{{NavI == 3 ? '保 存' : '下一页'}}</div> -->
              <div class="btn" @click="next">下一页</div>
              <div class="btn btn_mr" @click="up" v-if="NavI !== 0">
                上一页
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
import RightNav from "../../components/RightNav";
import Wan from "../../components/wangEnduit/wangEnduitReport";
export default {
  name: "Surface",
  data() {
    return {
      flag: true,
      NavI: 0,
      zI: 2,
      cI: 4,
      major1: [],
      major2: [],
      rp_cgmc: "",
      rp_clasid: "",
      major1Value: "",
      major2Value: "",
      majorShow: "",
      majorShow1: "",
      ParentClassName: "",
      ClassName: "",
      textNav: [
        "申报人信息",
        "成果信息",
        "成果简介",
        "经济效益指标",
        "审核意见",
      ],
      ClassifyID: "",
      value: [
        {
          dzyx: "",
          yb: "",
          sblxrxm: "",
          sblxrzw: "",
          sblxrdh: "",
          sblxrsj: "",
          sblxrcz: "",
        },
        {
          cgmc: "",
          cgfl1: "",
          cgfl2: "",
          sbdw: "",
          tjdw: "",
          sbdwlx: "",
          sbdwgm: "",
          sbdwdz: "",
        },
        {
          cgly: "",
          cgnh: "",
          zycxd: "",
          sfzy: "",
          cgsyjl: "",
        },
        {
          csrxm1: "",
          csrzw1: "",
          csrzc1: "",
          csrxm2: "",
          csrzw2: "",
          csrzc2: "",
          cycsrxm1: "",
          cycsrzw1: "",
          cycsrzc1: "",
          cycsrxm2: "",
          cycsrzw2: "",
          cycsrzc2: "",
          cycsrxm3: "",
          cycsrzw3: "",
          cycsrzc3: "",
          cycsrxm4: "",
          cycsrzw4: "",
          cycsrzc4: "",
          cycsrxm5: "",
          cycsrzw5: "",
          cycsrzc5: "",
          cycsrxm6: "",
          cycsrzw6: "",
          cycsrzc6: "",
          cycsrxm7: "",
          cycsrzw7: "",
          cycsrzc7: "",
          cycsrxm8: "",
          cycsrzw8: "",
          cycsrzc8: "",
          cycsrxm9: "",
          cycsrzw9: "",
          cycsrzc9: "",
          cycsrxm10: "",
          cycsrzw10: "",
          cycsrzc10: "",
        },
        {
          cgczsjn: "", //成果创造时间年
          cgczsjy: "", //成果创造时间月
          cgczsj: "", //成果创造时间
          cgyynx: "",
          cgssfw: "",
          cgxyjs: "",
          sbqynxye: "", //申报前一年效益额测算结果
          sbqynxyebz: "", //申报前一年效益额备注
          ssgn1: "", //实施各年开始年份
          ssgn2: "", //实施各年结束年份
          ssgnzn: "", //实施各年总年份
          ssgnljxye: "", //实施各年累计效益额测算结果
          ssgnljxyebz: "", //实施各年累计效益额备注
          pjndxyen1: "", //平均年度效益额开始年份
          pjndxyen2: "", //平均年度效益额结束年份
          pjndxyezn: "", //平均年度效益额总年份
          pjndxye: "", //平均年度效益额测算结果
          pjndxyebz: "", //平均年度效益额备注
          sbqyngxl: "", //申报前一年效益贡献率
          sbqyngxlbz: "", //申报前一年效益贡献率备注
        },
      ],
      ReportID: "",
    };
  },
  computed: {
    year() {
      var time = new Date();
      return time.getFullYear() - 1;
    },
  },
  created() {
    window.scrollTo(0, sessionStorage.getItem("scroll"));
  },
  mounted() {
    console.log(sessionStorage.getItem("isListGo"));

    if (sessionStorage.getItem("isListGo") == "true") {
      this.ReportID = sessionStorage.getItem("reportID");
    } else {
      this.ReportID = sessionStorage.getItem("ReportID");
    }
    if (!sessionStorage.getItem("name")) {
      this.$router.replace("/Declare");
    }

    this.getValur();
    this.getMajor1Value();
    this.getReportID();
  },

  methods: {
    // 成果分类显示
    getReportID(id) {
      console.log(id, "fa");
    },
    showCgfl(i) {
      if (i == 1) {
        this.majorShow = false;
      } else {
        this.majorShow1 = false;
      }
    },
    // 导航栏点击
    getNav(i) {
      this.NavI = i;
    },
    //取得已经填写的报表数据
    getValur() {
      let that = this;
      that.$axios
        .post(
          "reportcontent/info?ReportID=" +
          (that.$route.query.ReportID || that.ReportID) +
          "&token=" +
          sessionStorage.getItem("token")
        )
        .then(function (res) {
          console.log(res, 4569);
          if (res.data.code == 10000) {
            that.ClassName = res.data.category.ClassName;
            that.ParentClassName = res.data.category.ParentClassName;
            if (res.data.category.ParentClassName) {
              that.majorShow = true;
              that.majorShow1 = true;
            }
            that.value[1].cgfl1 = res.data.category.ParentClassName ? res.data.category.ParentClassName : ''
            that.value[1].cgfl2 = res.data.category.className ? res.data.category.className : ''

            // that.ClassifyID=res.data.category.ClassifyID
            if (res.data.category.ClassifyID) {
              that.ClassifyID = res.data.category.ClassifyID;
              //  that.value[1].cgfl=res.data.category.ClassifyID
            }
            let data = res.data.data;
            for (let i = 0; i < data.length; i++) {
              if (that.value[0][data[i].Title] !== undefined) {
                that.value[0][data[i].Title] = data[i].Content;
              } else if (that.value[1][data[i].Title] !== undefined) {
                that.value[1][data[i].Title] = data[i].Content;

                // if(data[i].Title=="cgfl"&&data[i].Content){
                //   console.log("title")
                //   that.majorShow=true
                //   that.major2Value=data[i].Content
                // }
              } else if (that.value[2][data[i].Title] !== undefined) {
                that.value[2][data[i].Title] = data[i].Content;
              } else if (that.value[3][data[i].Title] !== undefined) {
                that.value[3][data[i].Title] = data[i].Content;
              } else if (that.value[4][data[i].Title] !== undefined) {
                that.value[4][data[i].Title] = data[i].Content;
              }
            }
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function () { });
    },
    // getNavI(i) {
    //   for (let key in this.value[this.NavI]) {
    //     if (!this.value[this.NavI][key]) {
    //       continue;
    //     }
    //     this.addLattice(key, this.value[this.NavI][key]);
    //   }
    //   this.NavI = i;
    // },
    up() {
      if (this.NavI > 0) {
        this.NavI = this.NavI - 1;
      }
      // if(this.NavI==1){
      //   this.value[1].cgfl=""
      // }
    },
    next() {
      let that = this
      if (this.NavI != this.textNav.length - 1) {
        // for (let key in this.value[this.NavI]) {
        //   this.addLattice(key, this.value[this.NavI][key]);
        // }

        // 不知道为什么要做替换逻辑 先备注
        // for (let key in this.value[3]) {
        //   // if (!this.value[3][key]) {
        //   //   continue;
        //   // }
        //   // console.log(this.value[3][key], 333);
        //   this.value[3][key] = this.value[3][key]
        //     .replace("#", "%23")
        //     .replace("+", "%2b")
        //     .replace("$", "%24")
        //     .replace("^", "%5e")
        //     .replace("&", "%26")
        //     .replace("*", "%2a")
        //     .replace("=", "%3d")
        //     .replace("(", "%28")
        //     .replace(")", "%29");
        //   this.addLattice(key, this.value[3][key]);
        // }
        this.flag = true
        for (let key in this.value[0]) {
          if (!this.value[0][key]) {
            let element = document.getElementById(key)
            element.classList.add("input-warning")
            this.flag = false
          }
        }

        if (this.NavI == 1) {
          for (let key in this.value[1]) {
            if (!this.value[1][key]) {
              let element = document.getElementById(key)
              if (element) {
                element.classList.add("input-warning")
                this.flag = false
              }
            }
          }
          var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
          // console.log(userinfo.CompanyName.trim())
          // console.log(this.value[1].sbdw)
          if (userinfo.CompanyName.trim() != this.value[1].sbdw) {
            this.$alert(
              "申报单位与所属企业账号不一致，请注册本单位企业账号，并在本单位企业账号下注册个人账号，方可申报成果",
              "",
              {
                confirmButtonText: "确定",
                callback: () => {
                  this.value[1].sbdw = "";
                },
              }
            );
            return;
          }
        }
        if (this.flag) {
          this.NavI = this.NavI + 1;
        } else {
          this.$message.error("请填写必填项");
        }
      } else {
        console.log(that.ReportID);
        sessionStorage.setItem("isTable", false);
        //更新成果名称、成果类型到report表
        console.log("刷新标题");
        if (this.value[1].cgmc.length > 0) {
          that.$axios
            .post(
              "report/updateTitle",

              this.$qs.stringify({
                ReportID: that.$route.query.ReportID || that.ReportID,
                Title: this.value[1].cgmc,
                token: sessionStorage.getItem("token"),
              })
            )
            .then(function (res) {
              console.log(res, "1111111111");
              if (res.data.code == 10000) {
                that.$message({ message: "保存成功", type: "success" });
                that.$router.push({ path: "/Report", query: { ReportID: that.$route.query.ReportID || that.ReportID } });
              }
            })
            .catch(function () { });
        }
        // console.log(that.value[1].cgfl, 7777777);
        for (let key in this.value[this.NavI]) {
          if (!this.value[this.NavI][key]) {
            continue;
          }

          this.addLattice(key, this.value[this.NavI][key]);
        }
      }
    },
    next1() {
      let that = this;
      if (this.NavI == 3) {
        for (var key in this.value[4]) {
          // if (!this.value[4][key]) {
          //   continue;
          // }
          this.value[4].cgczsj =
            this.value[4].cgczsjn + "年" + this.value[4].cgczsjy + "月";
          if (key != "cgxyjs") {
            this.value[4][key] = this.value[4][key]
              .replace("#", "%23")
              .replace("+", "%2b")
              .replace("$", "%24")
              .replace("^", "%5e")
              .replace("&", "%26")
              .replace("*", "%2a")
              .replace("=", "%3d")
              .replace("(", "%28")
              .replace(")", "%29");
          }

          this.addLattice(key, this.value[4][key]);
        }
      }
      if (this.NavI == 4) {
        if (that.$route.query.ReportID) {
          console.log(that.$route.query.ReportID);
          this.$router.push("/Report?ReportID=" + that.$route.query.ReportID);
        } else {
          this.$router.push("/Report");
          console.log(sessionStorage.getItem("isTable"), 222222);
        }
      }
      if (that.major2Value) {
        console.log(this.major2Value, 666666666);
        that.value[1].cgfl = that.major1Value + "——" + that.major2Value;
        console.log(that.value[1].cgfl);
      } else if (that.ClassName) {
        that.value[1].cgfl = that.ParentClassName + "——" + that.ClassName;
      }
      if (this.NavI != this.textNav.length - 1) {
        for (let key in this.value[this.NavI]) {
          // if (!this.value[this.NavI][key]) {
          //   continue;
          // }

          // this.value[this.NavI][key] = this.value[this.NavI][key]
          //   .replace("#", "%23")
          //   .replace("+", "%2b")
          //   .replace("$", "%24")
          //   .replace("^", "%5e")
          //   .replace("&", "%26")
          //   .replace("*", "%2a")
          //   .replace("=", "%3d")
          //   .replace("(", "%28")
          //   .replace(")", "%29");
          // console.log("dddd", this.value[this.NavI][key], 456);


          this.addLattice(key, this.value[this.NavI][key]);
        }

        for (let key in this.value[3]) {
          // if (!this.value[3][key]) {
          //   continue;
          // }
          // console.log(this.value[3][key], 333);
          this.value[3][key] = this.value[3][key]
            .replace("#", "%23")
            .replace("+", "%2b")
            .replace("$", "%24")
            .replace("^", "%5e")
            .replace("&", "%26")
            .replace("*", "%2a")
            .replace("=", "%3d")
            .replace("(", "%28")
            .replace(")", "%29");
          this.addLattice(key, this.value[3][key]);
        }
        for (let key in this.value[0]) {
          if (!this.value[0][key]) {
            this.$message.error("请填写必填项");
            return;
          }
        }

        if (this.NavI == 1) {
          for (let key in this.value[1]) {
            if (!this.value[1][key]) {
              this.$message.error("请填写必填项");
              return;
            }
          }
          var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
          // console.log(userinfo.CompanyName.trim())
          // console.log(this.value[1].sbdw)
          if (userinfo.CompanyName.trim() != this.value[1].sbdw) {
            this.$alert(
              "申报单位与所属企业账号不一致，请注册本单位企业账号，并在本单位企业账号下注册个人账号，方可申报成果",
              "",
              {
                confirmButtonText: "确定",
                callback: () => {
                  this.value[1].sbdw = "";
                },
              }
            );
            return;
          }
          that.$axios
            .post(
              "report/save",
              that.$qs.stringify({
                token: sessionStorage.getItem("token"),
                ID: that.$route.query.ReportID || that.ReportID,
                ClassifyID: that.ClassifyID,
                Title: that.value[1].cgmc,
                MouldID: "MD1",
              })
            )
            .then((res) => {
              console.log(res, "cgfl");
            });
        }
        this.NavI = this.NavI + 1;
      } else {
        console.log(that.ReportID);
        sessionStorage.setItem("isTable", false);
        //更新成果名称、成果类型到report表
        console.log("刷新标题");
        if (this.value[1].cgmc.length > 0) {
          that.$axios
            .post(
              "report/updateTitle",

              this.$qs.stringify({
                ReportID: that.$route.query.ReportID || that.ReportID,
                Title: this.value[1].cgmc,
                token: sessionStorage.getItem("token"),
              })
            )
            .then(function (res) {
              console.log(res, "1111111111");
              if (res.data.code == 10000) {
                that.$message({ message: "提交成功", type: "success" });
                that.$router.push("/Report");
              }
            })
            .catch(function () { });
        }
        // console.log(that.value[1].cgfl, 7777777);
        for (let key in this.value[this.NavI]) {
          if (!this.value[this.NavI][key]) {
            continue;
          }

          this.addLattice(key, this.value[this.NavI][key]);
        }
      }
    },
    getMajor1Value() {
      console.log("223222");
      let that = this;
      that.$axios
        .post("classification/index?SuperiorD=0")
        .then(function (res) {
          if (res.data.code == 10000) {
            console.log("223", res.data.data.list);
            that.major1 = res.data.data.list;
          } else {
            console.log("223222" + res.data.data.list);
          }
        });
    },
    getmajor2: function () {
      let that = this;
      that.major2 = [];
      let element1 = document.getElementById('cgfl1')
      element1.classList.remove("input-warning")
      that.value[1].cgfl1 = that.major1Value

      this.major1.forEach((val) => {
        if (that.major1Value == val.Classname) {
          // that.value[1].cgfl=val.Classname
          that.$axios
            .post("classification/index?SuperiorD=" + val.ID)
            .then(function (res) {
              console.log(res);
              if (res.data.code == 10000) {
                console.log("22355", res.data.data.list);
                that.major2 = res.data.data.list;
              } else {
                console.log("223222" + res.data.data.list);
              }
            });
        }
      });
    },
    getmajor3: function () {
      let that = this;

      let value = that.major1Value + "——" + that.major2Value;
      let element2 = document.getElementById('cgfl2')
      element2.classList.remove("input-warning")
      that.addLattice('cgfl', value)
      that.value[1].cgfl2 = that.major2Value

      this.major2.forEach((val) => {
        if (that.major2Value == val.Classname) {
          // that.value[1].cgfl=val.Classname
          that.ClassifyID = val.ID;
          console.log(that.ClassifyID);
          that.$axios
            .post(
              "report/save",
              that.$qs.stringify({
                token: sessionStorage.getItem("token"),
                ID: that.$route.query.ReportID || that.ReportID,
                ClassifyID: that.ClassifyID,
                Title: that.value[1].cgmc,
                MouldID: "MD1",
              })
            )
            .then((res) => {
              console.log(res, "cgfl");
            });
        }
      });
    },
    //时间处理
    addTimeLattice(Content1, Content2) {
      let that = this;
      if (Content1 && Content2) {
        const content = this.value[4].cgczsjn + "年" + this.value[4].cgczsjy + "月"
        that.addLattice('cgczsj', content)
      }
    },
    // 公式处理

    //添加每项列表数据到接口
    addLattice(Title, Content) {
      let that = this;
      console.log(that.ReportID, this.value[1].sbdw);
      // if
      let element = document.getElementById(Title)
      if (element) {
        element.classList.remove("input-warning")
      }
      // var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      // if (userinfo.CompanyName != this.value[1].sbdw) {
      //   return
      // } else {
      that.$axios
        .post(
          "reportcontent/save?ReportID=" +
          (that.$route.query.ReportID || that.ReportID) +
          "&token=" +
          sessionStorage.getItem("token"),
          that.$qs.stringify({
            Title: Title,
            Content: Content,
          })
        )
        .then((res) => {
          console.log(res, 111);
        });
      // }
    },
    removeClass(obj, cls) {
      const has = obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
      if (has) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        obj.className = obj.className.replace(reg, ' ');
      }
    }
  },
  components: {
    Wan,
    Head,
    Foot,
    decLeftNav,
    RightNav,
  },
};
</script>
<style lang="less" >
#Surface {
  .editor {
    text-align: left;

    .text {
      min-height: 50px;
    }
  }
}
</style>
<style lang="less" scoped>
#Surface {
  width: 100%;
  min-width: 1000px;

  .surface {
    margin-top: 0.4rem;
    width: 100%;
    padding: 0 1.35rem;
    font-size: 0.18rem;
    display: flex;
    align-items: stretch;

    .leftNav {
      padding-right: 0.4rem;
      border-right: 0.01rem solid #e4e4e4;
    }

    .Main {

      // width: 100%;
      .explain {
        height: 1.6rem;
        margin: 0 0 0.2rem 0.4rem;
        border: 0.01rem solid #949494;
        padding: 0.1rem 0.2rem;
        line-height: 2;

        >div {
          display: flex;
          align-items: center;
          font-size: 0.18rem;
          font-weight: bold;

          img {
            margin-right: 0.14rem;
          }
        }

        p {
          font-size: 0.16rem;

          a:hover {
            color: #57a6f7;
          }
        }

        p:nth-of-type(2) {
          display: flex;

          img {
            // width: 8.2rem;
            margin-left: 0.15rem;
          }
        }

        .address {
          display: flex;
          align-items: center;

          img {
            margin: 0 0.08rem 0 0.2rem;
          }
        }
      }

      .mainIn {
        width: 100%;
        min-height: 9.5rem;
        display: flex;
        align-items: stretch;
        justify-content: space-between;

        .textNav {
          width: 2rem;
          margin-left: 0.4rem;

          >.nTitle {
            width: 100%;
            height: 0.55rem;
            display: flex;
            align-items: center;
            background: #2d65d2;
            padding: 0.15rem;
            color: #ffffff;

            >img {
              width: 0.2rem;
              margin-right: 0.1rem;
            }
          }

          >ul {
            width: 100%;
            border: 0.01rem solid #949494;
            font-size: 0.15rem;
            height: calc(100% - 0.55rem);

            >li {
              cursor: pointer;
              color: #949494;
              padding: 0.15rem;
              width: 100%;
              display: flex;
              align-items: center;

              >div {
                width: 0.1rem;
                height: 0.1rem;
                border-radius: 50%;
                background: #949494;
                margin-right: 0.15rem;
              }

              &.active {
                color: #2d65d2;

                >div {
                  background: #2d65d2;
                }
              }
            }
          }
        }

        .Table {
          width: 11rem;
          border: 0.01rem solid #949494;
          padding: 0.3rem;

          >#tTitle {
            width: 100%;
            border-left: 0.05rem solid #2d65d2;
            padding-left: 0.15rem;
          }

          >.tMain {
            margin-top: 0.2rem;

            // width: 7rem;
            input,
            select {
              width: 70%;
              padding-left: 0.1rem;
              height: 0.45rem;
              font-size: 0.15rem;
              margin-bottom: 0.15rem;
            }

            table {
              width: 100%;
              border-collapse: collapse;

              th {
                height: 0.5rem;
                border: 0.01rem solid #949494;
              }

              td {
                border: 0.01rem solid #949494;
                height: 0.45rem;
              }

              input {
                width: 100%;
                height: 0.43rem;
                margin-bottom: 0;
                outline: 0;
                border: 0;
              }
            }

            textarea {
              width: 100%;
              padding: 0.15rem 0.2rem;
              font-size: 0.15rem;
              margin-bottom: 0.15rem;
              height: 1.5rem;
              resize: none;
            }

            >.tMInput {
              .yj {
                height: 1.5rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 0.1rem 0.3rem;

                >div {
                  text-align: right;

                  >span {
                    margin-right: 0.3rem;
                  }
                }
              }

              .gz {
                height: 1rem;

                div {
                  text-align: right;
                  padding-right: 0.3rem;

                  >span {
                    margin-right: 0.3rem;
                  }
                }
              }

              .space {
                margin-top: 0.05rem;

                >span {
                  display: inline-block;
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }

              .cgfl {
                display: flex;
                align-items: center;

                // margin-top: 0.4rem;
                .major2Value {
                  width: 70%;
                  height: 0.45rem;
                  line-height: 0.45rem;
                  border: 1px solid #aaa;
                  padding-left: 0.1rem;
                  position: relative;

                  .icon-triangle-dowm {
                    width: 0;
                    height: 0;
                    border: 4px solid #000;
                    border-left-color: transparent;
                    border-right-color: transparent;
                    border-bottom: none;
                    position: absolute;
                    right: 0.1rem;
                    top: 0.18rem;
                  }
                }

                >span {
                  margin-left: 0.1rem;
                  color: red;
                }
              }

              .major2Value {
                width: 70%;
                height: 0.45rem;
                line-height: 0.45rem;
                border: 1px solid #aaa;
                padding-left: 0.1rem;
              }

              display: flex;
              flex-wrap: wrap;

              .t {
                width: 100%;
              }

              >div {
                padding-bottom: 0.3rem;
                width: 48%;
                margin-right: 0.2rem;

                >div {
                  font-size: 0.15rem;
                  margin-bottom: 0.15rem;
                }

                >span {
                  color: red;
                  margin-left: 0.1rem;
                }
              }

              >.title {
                padding-top: 0.3rem;
                padding-bottom: 0;
                font-size: 0.15rem;
                margin-bottom: 0.15rem;
              }

              // .btn {
              //   width: 100%;
              //   display: flex;
              //   justify-content: space-between;
              //   .btnI {
              //     cursor: pointer;
              //     margin-top: 0.4rem;
              //     width: 1rem;
              //     height: 0.3rem;
              //     display: flex;
              //     justify-content: center;
              //     align-items: center;
              //     color: #ffffff;
              //     background: #2d65d2;
              //     float: right;
              //     &.none {
              //       background: #f3252f;
              //     }
              //   }
              // }
            }

            >.btn {
              cursor: pointer;
              margin-top: 0.4rem;
              width: 1.5rem;
              height: 0.4rem;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #ffffff;
              background: #2d65d2;
              float: right;
            }

            >.btn_mr {
              margin-right: 0.2rem;
            }
          }
        }
      }
    }
  }
}

.input-warning {
  border: 1px solid red;
}
</style>